import type { OnyxMaybeArray, OnyxSuggestion } from '@onyx/angular';
import { castArray } from 'lodash';
import type { FleetIdentifierPipe } from '../../../../common/pipes/fleet-identifier.pipe';
import type {
  Fleet,
  SimplifiedFleet,
} from '../../../fleet/common/interfaces/fleet';

export const getFleetSuggestions = (
  fleet: OnyxMaybeArray<Fleet | SimplifiedFleet>,
  fleetIdentifierPipe: FleetIdentifierPipe,
): OnyxSuggestion<string>[] => {
  return castArray(fleet).map((fleet) => ({
    name: fleetIdentifierPipe.transform(fleet),
    value: fleet.uuid,
  }));
};
